import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { forkJoin } from 'rxjs';
import { AnaliseDesconto } from 'src/app/models/analise-desconto';
import { AnaliseDescontoQuestionario } from 'src/app/models/analise-desconto-questionario';
import { AnaliseDescontoStatus, TipoAplicacao, TipoArquivo } from 'src/app/models/enum';
import { AnaliseDescontoAnexoService } from 'src/app/services/analise-desconto-anexo.service';
import { AnaliseDescontoSolicitacaoCampoPersonalizadoSelecionadoService } from 'src/app/services/analise-desconto-solicitacao-campo-personalizado-selecionado.service';
import { AnaliseDescontoService } from 'src/app/services/analise-desconto.service';
import { CampoPersonalizadoService } from 'src/app/services/campo-personalizado.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { PremissasService } from 'src/app/services/premissas.service';
import swal from 'sweetalert2';
import { JustificativaModalComponent } from '../justificativa-modal/justificativa-modal.component';
import { HistoricoAnaliseDescontoComponent } from 'src/app/historico-analise-desconto/historico-analise-desconto.component';

// jquery
declare const $: any;

@Component({
  selector: 'app-analise-desconto-solicitacao-modal',
  templateUrl: './analise-desconto-solicitacao-modal.component.html',
  styleUrls: ['./analise-desconto-solicitacao-modal.component.scss']
})
export class AnaliseDescontoSolicitacaoModalComponent implements OnInit {

  tabelas = [];
  editavel = false;
  mostrarSalvar: boolean = false;
  idCupom: string = '';
  valorPedido: number = 0;
  analiseDesconto: AnaliseDesconto = new AnaliseDesconto();
  anexos: any[] = [];
  AnaliseDescontoStatus = AnaliseDescontoStatus;
  orcamento = false;

  podeSolicitar = false;

  questionarioConclusao: AnaliseDescontoQuestionario[];

  public config: PerfectScrollbarConfigInterface = {};

  @ViewChild('historicoAnaliseDescontoComp', { static: false }) historicoAnaliseDescontoComp: HistoricoAnaliseDescontoComponent;

  tipoArquivo = TipoArquivo.AnaliseDescontoAnexo;

  constructor(
    private dialogRef: MatDialogRef<AnaliseDescontoSolicitacaoModalComponent>,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private analiseDescontoSolicitacaoCampoPersonalizadoSelecionadoService: AnaliseDescontoSolicitacaoCampoPersonalizadoSelecionadoService,
    private analiseDescontoService: AnaliseDescontoService, @Inject(MAT_DIALOG_DATA) public data: any,
    private analiseDescontoAnexoService: AnaliseDescontoAnexoService,
    private pedidoService: PedidoService, private router: Router, public dialog: MatDialog
  ) {
    if (this.data !== null && this.data !== undefined) {
      this.mostrarSalvar = this.data.mostraSalvar;
      this.idCupom = this.data.idCupom;
    }
  }

  async ngOnInit() {
    await this.buscarDados();
  }

  async buscarDados(atualizarHistorico?) {
    await this.buscarDadosPedido();
    await this.buscarAnaliseDescontoAtual();

    if (this.analiseDesconto.id !== null && this.analiseDesconto.id !== undefined &&
      this.analiseDesconto.id > 0) {
      this.buscarAnexos();
    }

    this.montarCampos();

    if (atualizarHistorico && this.historicoAnaliseDescontoComp !== null && this.historicoAnaliseDescontoComp !== undefined) {
      this.historicoAnaliseDescontoComp.buscarAnalisesDoPedido();
    }
  }

  fechar() {
    console.log('anexos:', this.anexos);
    this.dialogRef.close();
  }

  async salvar(f: NgForm) {

    if (f.invalid) {
      return;
    }

    try {
      this.carregandoService.mostra('salvar');
      if (this.analiseDesconto.id === null || this.analiseDesconto.id === undefined || this.analiseDesconto.id === 0) {
        this.analiseDesconto.status = AnaliseDescontoStatus.NaoAtribuida;
        this.anexos.forEach(p => p.id = 0);
      }
      this.analiseDesconto.id = (await this.analiseDescontoService.salvar(this.analiseDesconto).toPromise()).analise.id;
      await this.salvarQuestionario();
      await this.excluirAnexos();
      await this.salvarAnexos();
      this.notificacaoService.sucesso('Solicitação enviada com sucesso!!!');
      this.dialogRef.close(true);
    } catch (erro) {
      this.notificacaoService.erro('Erro ao salvar');
    } finally {
      this.carregandoService.esconde('salvar');
    }
  }

  async salvarQuestionario() {

    try {
      this.carregandoService.mostra('salvarQuestionario');
      await this.analiseDescontoSolicitacaoCampoPersonalizadoSelecionadoService.salvar(this.tabelas, this.analiseDesconto.id).toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('salvarQuestionario');
    }
  }

  montarCampos() {
    this.carregandoService.mostra('montarCampos');

    this.analiseDescontoSolicitacaoCampoPersonalizadoSelecionadoService.montarParaCadastrar(this.analiseDesconto.id, this.idCupom).subscribe(dados => {
      this.tabelas = dados;
      this.carregandoService.esconde('montarCampos');
    }, (erro) => {
      this.carregandoService.esconde('montarCampos');
      this.notificacaoService.erro(erro);
    });
  }

  async buscarAnaliseDescontoAtual() {
    try {
      this.carregandoService.mostra('buscarAnaliseDescontoAtual');
      const analise = await this.analiseDescontoService.consultarAnaliseAtualPorIdCupom(this.idCupom).toPromise();
      if (analise !== null && analise !== undefined) {
        this.analiseDesconto = analise;
        this.editavel = this.analiseDesconto.status === AnaliseDescontoStatus.NaoIniciada || this.analiseDesconto.status === AnaliseDescontoStatus.Pausada;

        if (!this.editavel) {
          this.buscarQuestionarioPreenchido(this.analiseDesconto.status === AnaliseDescontoStatus.DescontoConcedido ? TipoAplicacao.AnaliseDescontoConclusaoPositiva : TipoAplicacao.AnaliseDescontoConclusaoNegativa);
        }

      } else {
        this.fazerNovaAnalise();
      }
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarAnaliseDescontoAtual');
    }
  }

  async buscarDadosPedido() {
    try {
      this.carregandoService.mostra('buscarDadosPedido');
      const dadosPedido: any = await this.pedidoService.buscarDadosPedidoParaAnaliseDesconto(this.idCupom).toPromise();
      this.podeSolicitar = dadosPedido.apto;
      this.valorPedido = dadosPedido.valorTotal;
      this.orcamento = dadosPedido.orcamento;
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarDadosPedido');
    }
  }

  buscarAnexos() {
    this.carregandoService.mostra('buscarAnexos');

    this.analiseDescontoAnexoService.consultarPorIdAnaliseDesconto(this.analiseDesconto.id, this.idCupom).subscribe(anexosBanco => {
      if (anexosBanco !== null && anexosBanco !== undefined) {
        this.anexos = anexosBanco;
      } else {
        this.anexos = [];
      }
      this.carregandoService.esconde('buscarAnexos');
    }, (erro) => {
      this.carregandoService.esconde('buscarAnexos');
      this.notificacaoService.erro(erro);
    });
  }

  async excluirAnexos() {

    const acoes: any[] = [];

    this.anexos.filter(a => a.excluido && a.id !== null && a.id !== undefined && a.id > 0).forEach(a => {
      acoes.push(this.analiseDescontoAnexoService.excluir(a.id).toPromise());
    });

    await Promise.all(acoes);
  }

  async salvarAnexos() {
    const acoes: any[] = [];

    this.anexos.filter(a => !a.excluido).forEach(a => {
      acoes.push(this.salvarAnexo(a));
    });

    await Promise.all(acoes);
  }

  salvarAnexo(anexo: any) {
    anexo.idAnalise = this.analiseDesconto.id;

    const dados = new FormData();
    if ((anexo.id === null || anexo.id === undefined || anexo.id === 0) && (anexo.idAnexo === null || anexo.idAnexo === undefined || anexo.idAnexo === 0)) {
      dados.append('arquivo_anexo', anexo);
      dados.append('arqui[arquivo]', anexo.name);
    } else {
      dados.append('arqui[arquivo]', anexo.arquivo);
    }

    dados.append('arqui[id]', anexo.id === null || anexo.id === undefined || anexo.id === 0 ? '0' : anexo.id.toString());
    dados.append('arqui[descricao]', anexo.descricao);
    dados.append('arqui[idAnalise]', anexo.idAnalise);
    dados.append('arqui[idAnexo]', anexo.idAnexo ? anexo.idAnexo.toString() : '0');

    return this.analiseDescontoAnexoService.salvar(dados).toPromise();
  }

  calcularDesconto() {
    return (this.analiseDesconto.valorDoPedido - this.analiseDesconto.valorSolicitado) * 100 / this.analiseDesconto.valorDoPedido;
  }

  campoInvalido(f, campo) {
    const c = f.controls[campo];

    return c && c.invalid && (c.dirty || c.touched || f.submitted);
  }

  fazerNovaAnalise(limparQuestAnexo?) {
    this.analiseDesconto = new AnaliseDesconto();
    this.analiseDesconto.id = 0;
    this.analiseDesconto.idCupom = this.idCupom;
    this.analiseDesconto.valorDoPedido = this.valorPedido;
    this.editavel = true;

    if (limparQuestAnexo) {
      this.montarCampos();
      this.buscarAnexos();
    }
  }

  buscarQuestionarioPreenchido(tipoAplicacao: TipoAplicacao) {
    this.carregandoService.mostra('buscarQuestionarioPreenchido');
    this.analiseDescontoService.consultarQuestionarioPreenchido(this.analiseDesconto.id, tipoAplicacao).subscribe(dados => {
      this.questionarioConclusao = dados;
      this.carregandoService.esconde('buscarQuestionarioPreenchido');
    }, (erro) => {
      this.carregandoService.esconde('buscarQuestionarioPreenchido');
      this.notificacaoService.erro(erro);
    });
  }

  irParaPedidoAplicandoDesconto() {

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    this.router.onSameUrlNavigation = 'reload';

    this.router.navigate([`${(this.orcamento ? 'orcamentos' : 'pedidos')}/editar/${this.analiseDesconto.idCupom}`], {
      state: {
        descontoDaAnalise: this.analiseDesconto.descontoAutorizado
      }
    });

    this.dialogRef.close();
  }

  async cancelarSolicitacao() {

    swal({
      title: 'Atenção!!',
      html:
        'Deseja realmente <span class="negrito">cancelar a solicitação</span>?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false,
    }).then(async (result) => {
      if (result.value) {
        const largura = Number(($('body').width()));

        const dialogRef = this.dialog.open(JustificativaModalComponent, {
          width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
          data: { tipo: 1 },
          panelClass: 'modal-card'
        });

        dialogRef.afterClosed().subscribe(async (resultJust) => {
          if (resultJust) {
            await this.alterarStatusAnalise(AnaliseDescontoStatus.Cancelada, resultJust);
            await this.buscarDados(true);
          }
        });
      }
    });
  }

  async alterarStatusAnalise(status, obs) {
    try {
      this.carregandoService.mostra('alterarStatusAnalise');
      return await this.analiseDescontoService.alterarStatusAnalise(this.analiseDesconto.id, status, obs).toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('alterarStatusAnalise');
    }
  }
}
